import { Controller } from "@hotwired/stimulus"

// Filtre une liste d'éléments portant data-filter-item / data-filter-value.
// Déclaré dans les vues depuis le début, mais aucun contrôleur ne portait ce
// nom : Stimulus ignore en silence un data-controller inconnu, et le filtrage
// était en réalité assuré par un <script> inline — bloqué par la CSP.
export default class extends Controller {
  filter(event) {
    const terme = (event.target.value || "").toLowerCase().trim()
    this.element.querySelectorAll("[data-filter-item]").forEach((item) => {
      const valeur = (item.dataset.filterValue || "").toLowerCase()
      item.classList.toggle("hidden", terme !== "" && !valeur.includes(terme))
    })
  }
}
